import React from 'react';
import { IconButton, useMediaQuery } from '@mui/material';
import './styles.css';
import { sxIconButton } from './sxProps';
import aPlus from '../../assets/images/A+.png';
import a from '../../assets/images/A.png';
import contrast from '../../assets/images/Contrast.png';
import { useAccessibility } from '../../Store/contexts/AccessibilityContext';
import AMinus from '../../assets/svgs/AMinus';
import APlus from '../../assets/svgs/APlus';
import A from '../../assets/svgs/A';
import Contrast from '../../assets/svgs/Contrast';


const Accessibility: React.FC = () => {

  const {
    toggleContrastMode,
    increaseFontSize,
    decreaseFontSize,
    resetFontSize,
    contrastMode,
    buttonStyleAccessibility
  } = useAccessibility();

  return (
    <div className={`menu-accessibility-align ${contrastMode && 'contrast-background'}`}>
      <IconButton aria-label="Diminuir fonte" style={buttonStyleAccessibility} onClick={() => decreaseFontSize()} sx={sxIconButton}>
        <AMinus/>
      </IconButton>
      <IconButton aria-label="Voltar fonte ao tamanho padrão" style={buttonStyleAccessibility} onClick={() => resetFontSize()} sx={sxIconButton}>
        <A/>
      </IconButton>
      <IconButton aria-label="Aumentar fonte" style={buttonStyleAccessibility} onClick={() => increaseFontSize()} sx={sxIconButton}>
        <APlus/>
      </IconButton>
      <IconButton aria-label="Modo de alto contraste" style={buttonStyleAccessibility} onClick={() => toggleContrastMode()} sx={sxIconButton}>
        <Contrast/>
      </IconButton>
    </div>
  );
};

export default Accessibility;
